/**
 * Language: English.
 */
export default {
    time: {
        openingHoursTitle: "Opening hours",
        at: "at",
        to: "to",
        opensToday: "Opens today",
        opens: "Opens",
        open24_7: "Open 24/7",
        closed: "Closed",
        openUntil: "Open today until",
        daily: "Open daily from",
        month: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ],
        monthAbbr: [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ],
        dayOfWeek: [
            'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 
        ],
        dayOfWeekAbbr: [
            'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 
        ],
        temporarilyClosed: "Temporarily closed",
        opened: "",
        today: ""
    },
    search: {
        placeholder: "Street, city or zip code",
        submitLabel: "Search",
        clearLabel: "Clear search",
        yourLocation: "Your location",
    },
    filtering: {
        servicesTitle: "Services",
        services: {
            WF: 'Wireless Hotspot',
            CD: 'Mobile Payment',
            DT: 'Drive-Thru',
            DR: 'Digital Rewards',
            hrs24: 'Open 24 hours per day',
            WA: 'Oven-warmed Food',
            LB: 'LaBoulange',
            XO: 'Mobile Order and Pay',
            VS: 'Verismo',
            NB: 'Nitro Cold Brew',
            CL: 'Starbucks Reserve-Clover Brewed',
        }
    },
    stores: {
        cta: {
            call: "Call",
            directions: "Directions",
            website: "Website",
            'club details': 'Club details',
            'view tariffs': 'Join now',
            'View Map': "View map",
            'View List': "View list"
        },
        messages: {
            initialHeader: "Start by searching a location to display nearby clubs",
            emptyHeader: "No club returned",
            initialBody: "or click on the map to select a club",
            emptyBody: "Please search for a different location or unselect your filters"
        }
    },
    directions: {
        avoidOptions: {
            highways: 'Highways',
            tolls: 'Tolls',
            ferries: 'Ferries'
        },
        unitOptions: {
            METRIC: 'km',
            IMPERIAL: 'miles'
        },
        options: "Route options",
        avoid: "Avoid",
        units: "Distance units",
        messages: {
            initialBody: "Search an origin and destination to see available routes and time travel.",
            error: "Sorry, we could not calculate driving directions",
            from: "from",
            to: "to",
            forTravelMode: "for the travel mode",
            via: "through",
            details: "Details",
            withoutTraffic: "without traffic",
            openGoogleMaps: "open in google maps"
        }
    },
    errors: {
        loadingLibrary: "Failed to load the {library} script",
        geolocationFailed: "User Geolocation failed",
        apiErrors:{
            "401": "Unauthorized",
            "403": "Forbidden",
            "429": "Too many requests",
            "500": "Internal server error",
            other: "An unexpected server error occurred"
        }
    },
};
